export default __webpack_public_path__ + "static/media/help-desk-8.057ae325.png";